// extracted by mini-css-extract-plugin
export default {"middleEllipsisText":"css_middleEllipsisText__iE0uc","sizer":"css_sizer__Zjkgh"};